import { AnimatePresence, motion } from 'motion/react';
import { Pin } from 'lucide-react';
import { staggerItem } from '@/lib/motion';
import { SidebarSection } from '@reflex/ui/components/sidebar/SidebarSection';
import { ActiveAgentRow } from '../ActiveAgentRow';
import type { Agent, AgentActivity } from '@/lib/types';

interface PinnedAgentSectionProps {
  agents: Agent[];
  collapsed: boolean;
  selectedId: string | null;
  activities: Map<string, AgentActivity>;
  onToggle: () => void;
  onSelect: (agent: Agent) => void;
  onArchive: (agent: Agent) => void;
  onDelete: (agent: Agent) => void;
  onTogglePin: (agent: Agent) => void;
  selectionMode?: boolean;
  selectedIds?: Set<string>;
  onToggleSelect?: (agent: Agent, shiftKey: boolean) => void;
}

export function PinnedAgentSection({
  agents,
  collapsed,
  selectedId,
  activities,
  onToggle,
  onSelect,
  onArchive,
  onDelete,
  onTogglePin,
  selectionMode = false,
  selectedIds,
  onToggleSelect,
}: PinnedAgentSectionProps) {
  if (!agents.length) return null;
  return (
    <SidebarSection
      label="Pinned"
      icon={<Pin className="h-3 w-3 shrink-0 text-muted-foreground" />}
      iconPosition="after"
      open={!collapsed}
      onOpenChange={() => onToggle()}
      data-testid="agent-sidebar-section-pinned"
      triggerTestId="agent-sidebar-section-toggle-pinned"
    >
      <AnimatePresence initial={false}>
        {agents.map((agent) => (
          <motion.div key={agent.id} {...staggerItem}>
            <ActiveAgentRow
              agent={agent}
              selected={selectedId === agent.id}
              activity={activities.get(agent.id) ?? 'stopped'}
              onSelect={onSelect}
              onArchive={onArchive}
              onDelete={onDelete}
              onTogglePin={onTogglePin}
              selectionMode={selectionMode}
              checked={selectedIds?.has(agent.id) ?? false}
              onToggleSelect={onToggleSelect}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </SidebarSection>
  );
}
